import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions} from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Rx';
import { AppConfig } from 'app/app.config';
import { FormGroup } from '@angular/forms';
import { environment } from 'environments/environment';

@Injectable()
export class ExpedienteService {
  public token: string;
  private headers: Headers = new Headers({'Content-Type': 'application/json'});
  constructor(private http: Http, private config: AppConfig) { }


  getUniversidades() {
    return this.http.get(environment.apiUrl + '/universidades').map((response: Response) => response.json());
}

getCentrosDisponibles(iduniversidad,idconvocatoria) {
  return this.http.get(environment.apiUrl + '/universidades/'+iduniversidad+'/'+idconvocatoria,this.jwt()).map((response: Response) => response.json());
}

  getAll(idconvocatoria) {
    return this.http.get(environment.apiUrl + '/expedientes/' + idconvocatoria, this.jwt()).map((response: Response) => response.json());
}

get(idconvocatoria, idcentro) {
  // tslint:disable-next-line:max-line-length
  console.log(environment.apiUrl + '/expedientes/' + idconvocatoria + '/' + idcentro)
  console.log(this.jwt())
  return this.http.get(environment.apiUrl + '/expedientes/' + idconvocatoria + '/' + idcentro, this.jwt()).map((response: Response) => response.json());
}


getEvaluadoresDisponibles(idconvocatoria, idcentro,idtipoevaluacion) {
  // tslint:disable-next-line:max-line-length
  return this.http.get(environment.apiUrl + '/expedientes/evaluadoresDisponibles/' + idconvocatoria + '/' + idcentro+"/"+idtipoevaluacion, this.jwt()).map((response: Response) => response.json());
}


put(idconvocatoria, idcentro, accion,FORM_AUTOINFORME ) {
  const parametros = idconvocatoria + '/' + idcentro;
  console.log(environment.apiUrl + '/expedientes/' + parametros);
      // tslint:disable-next-line:max-line-length
  console.log(JSON.stringify({operacion: accion, autoinforme: FORM_AUTOINFORME}));
  return this.http.put(environment.apiUrl + '/expedientes/' + parametros,{operacion: accion, autoinforme: FORM_AUTOINFORME}, this.jwt()).map((response: Response) => response.json());

}


delete(idconvocatoria, idcentro) {
  const parametros = idconvocatoria + '/' + idcentro;
      // tslint:disable-next-line:max-line-length
  return this.http.delete(environment.apiUrl + '/expedientes/' + parametros, this.jwt()).map((response: Response) => response.json());

}

postCentros(idconvocatoria,centros) {
  const parametros = idconvocatoria;
  console.log(environment.apiUrl + '/expedientes/' + parametros);
      // tslint:disable-next-line:max-line-length
  return this.http.put(environment.apiUrl + '/expedientes/' + parametros,{centros_nuevos: centros}, this.jwt()).map((response: Response) => response.json());

}




getDOCRESUMEN(idconvocatoria, idcentro) {
  const parametros = idconvocatoria + '/' + idcentro  ;
  console.log(this.jwtBlob());
      // tslint:disable-next-line:max-line-length
  let action = '/expediente/resumen/';
  console.log(environment.apiUrl + action + parametros);
  return this.http.get(environment.apiUrl + action + parametros, this.jwtBlob()).map((response: Response) => response.text());

}


getDOCAUTOINFORME(idconvocatoria, idcentro) {
  const parametros = idconvocatoria + '/' + idcentro ;
  console.log(this.jwtBlob());
  let action = '/expediente/autoinforme/';
  console.log(environment.apiUrl + action + parametros);
  return this.http.get(environment.apiUrl + action + parametros, this.jwtBlob()).map((response: Response) => response.text());

}



getDOCAYUDA(idconvocatoria, idcentro) {
  const parametros = idconvocatoria + '/' + idcentro ;
  console.log(this.jwtBlob());
  let action = '/expediente/ayuda/';
  console.log(environment.apiUrl + action + parametros);
  return this.http.get(environment.apiUrl + action + parametros, this.jwtBlob()).map((response: Response) => response.text());

}



getDOCALEGACIONES(idconvocatoria, idcentro) {
  const parametros = idconvocatoria + '/' + idcentro ;
  console.log(this.jwtBlob());
  let action = '/expediente/alegaciones/';
  console.log(environment.apiUrl + action + parametros);
  return this.http.get(environment.apiUrl + action + parametros, this.jwtBlob()).map((response: Response) => response.text());

}

getDOCTITULOS(idconvocatoria, idcentro) {
  const parametros = idconvocatoria + '/' + idcentro ;
  console.log(this.jwtBlob());
  let action = '/expediente/solicitud/';
  console.log(environment.apiUrl + action + parametros);
  return this.http.get(environment.apiUrl + action + parametros, this.jwtBlob()).map((response: Response) => response.text());

}

private jwt() {
  // create authorization header with jwt token
  const currentUser = JSON.parse(localStorage.getItem('currentUser'));
  if (currentUser && currentUser.token) {
      const headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
      return new RequestOptions({ headers: headers });
  }
}


private jwtBlob() {
  // create authorization header with jwt token
  const currentUser = JSON.parse(localStorage.getItem('currentUser'));
  if (currentUser && currentUser.token) {
      const headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
      return new RequestOptions({ headers: headers });
  }
}
}



// WEBPACK FOOTER //
// /app/src/app/services/expediente.service.ts